import { render, staticRenderFns } from "./indexSupervisionExpert.vue?vue&type=template&id=10588c64&scoped=true&"
import script from "./indexSupervisionExpert.vue?vue&type=script&lang=js&"
export * from "./indexSupervisionExpert.vue?vue&type=script&lang=js&"
import style0 from "./indexSupervisionExpert.vue?vue&type=style&index=0&id=10588c64&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10588c64",
  null
  
)

export default component.exports